import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Tabs,
  Tab,
  Box,
  Card,
  CardMedia,
  CardContent,
  Grid,
  Button,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import HomeIcon from "@mui/icons-material/Home";
import FastfoodIcon from "@mui/icons-material/Fastfood";

const MAX_DESCRIPTION_LENGTH = 50;

const menuData = {
  Inicio: [],
  Burritas: [
    {
      name: "Burrita de pierna",
      description: "",
      price: "$39",
      img: "imagenes/burrita_pierna.jpg",
    },
    {
      name: "Burrita tradicional",
      description: "Frijoles con pierna",
      price: "$30",
      img: "imagenes/burrita_tradicional.jpg",
    },
    {
      name: "Burrita de frijoles con queso",
      description: "",
      price: "$29",
      img: "imagenes/burrita_frijoles_queso.jpg",
    },
    {
      name: "Burro momia",
      description:
        "Jitomate, cebolla, crema, mostaza, catsup, queso blanco, salchicha y tocino",
      price: "$50",
      img: "imagenes/burro_momia.jpg",
    },
    {
      name: "Burra Cris",
      description:
        "Doble tortilla, salchicha, pierna, queso blanco y amarillo, jamón, tocino, lechuga, jitomate, cebolla, crema, catsup y mostaza",
      price: "$85",
      img: "imagenes/burrita_cris.jpg",
    },
    {
      name: "Burraneitor",
      description:
        "Bistec, chorizo, frijoles, cebolla guisada, queso y papas a la francesa",
      price: "$89",
      img: "imagenes/burraneitor.jpg",
    },
  ],
  Hamburguesas: [
    {
      name: "Hamburguesa",
      description:
        "Carne, queso blanco, queso amarillo, jamón, tocino, jitomate, cebolla, lechuga, crema, catsup, mostaza",
      price: "$70",
      img: "imagenes/hamburguesa.jpg",
    },
    {
      name: "Hamburguesa especial",
      description:
        "Carne, jamón, queso blanco, queso amarillo, tocino, salchicha, jitomate, cebolla, lechuga, crema, catsup, mostaza",
      price: "$80",
      img: "imagenes/hamburguesa_especial.jpg",
    },
    {
      name: "Hamburguesa doble",
      description:
        "Doble carne, doble jamón, doble queso blanco, doble queso amarillo, doble tocino, jitomate, cebolla, lechuga, crema, catsup, mostaza",
      price: "$120",
      img: "imagenes/hamburguesa_doble.jpg",
    },
    {
      name: "Hamburguesa cubana",
      description:
        "Carne, queso blanco, queso amarillo, jamón, salchicha, pierna, chorizo, jitomate, cebolla, lechuga, crema, catsup, mostaza",
      price: "$95",
      img: "imagenes/hamburguesa_cubana.jpg",
    },
    {
      name: "Hamburguesa doble cubana",
      description:
        "Doble carne, doble jamón, doble queso blanco, doble queso amarillo, doble tocino, doble pierna, doble salchicha, doble chorizo, jitomate, cebolla, lechuga, crema, catsup, mostaza",
      price: "$180",
      img: "imagenes/hamburguesa_doble_cubana.jpg",
    },
    {
      name: "Hamburguesa cardiaca",
      description:
        "Carne, jamón, huevo, jitomate queso blanco, amarillo, cebolla crema  catsup  mostaza lechuga",
      price: "$85",
      img: "imagenes/hamburguesa_cardiaca.jpg",
    },
  ],
  HotDogs: [
    {
      name: "Hot dog",
      description: "",
      price: "$29",
      img: "imagenes/hotdog.jpg",
    },
    {
      name: "Pierna Dogo",
      description: "Dogo normal con pierna extra",
      price: "$45",
      img: "imagenes/hotdog_pierna.jpg",
    },
    {
      name: "Huevo Dogo",
      description: "Dogo normal con huevo encima",
      price: "$39",
      img: "imagenes/hotdog_huevo.jpg",
    },
    {
      name: "Chile Dogo",
      description:
        "Dogo normal con chile güero y doble tocino. El chile lleva dentro una salchicha",
      price: "$45",
      img: "imagenes/hotdog_chile.jpg",
    },
    {
      name: "Chori Dogo",
      description: "Dogo normal con chorizo",
      price: "$40",
      img: "imagenes/choridogos.jpg",
    },
    {
      name: "Dogo especial",
      description: "Dogo normal con jamón y queso gratinado extra",
      price: "$39",
      img: "imagenes/hotdog_especial.jpg",
    },
    {
      name: "Dogo gratinado",
      description: "Dogo normal con queso gratinado extra",
      price: "$38",
      img: "imagenes/hotdog_gratinado.jpg",
    },
    {
      name: "Dogo Pacheco",
      description: "Dogo gigante con queso amarillo, jamón y cebolla guisada",
      price: "$88",
      img: "imagenes/hotdog_pacheco.jpg",
    },
  ],
  Molletes: [
    {
      name: "Molletes dulces",
      description: "Cajeta, fresa, miel lechera",
      price: "$25",
      img: "imagenes/mollete_dulce.jpg",
    },
    {
      name: "Mollete con fruta",
      description: "",
      price: "$43",
      img: "imagenes/mollete_fruta.jpg",
    },
    {
      name: "Mollete ranchero",
      description: "Frijoles y queso",
      price: "$35",
      img: "imagenes/mollete_ranchero.jpg",
    },
    {
      name: "Mollete ranchero estilo Paúl",
      description: "Frijoles, queso, jamón y tocino",
      price: "$45",
      img: "imagenes/mollete_ranchero_paul.jpg",
    },
    {
      name: "Mollete ranchero estilo García",
      description: "Frijoles, queso, huevo y tocino",
      price: "$45",
      img: "imagenes/mollete_ranchero_garcia.jpg",
    },
  ],
  Platillos: [
    {
      name: "Platillo de huevos con frijoles",
      description: "",
      price: "$95",
      img: "imagenes/platillo_frijoles_huevo.jpg",
    },
  ],
  Postres: [
    {
      name: "Arroz con leche chico",
      description: "",
      price: "$25",
      img: "imagenes/arroz_con_leche.jpg",
    },
    {
      name: "Arroz con leche mediano",
      description: "",
      price: "$30",
      img: "imagenes/arroz_con_leche.jpg",
    },
    {
      name: "Arroz con leche litro",
      description: "",
      price: "$60",
      img: "imagenes/arroz_con_leche.jpg",
    },
    {
      name: "Avena con leche chica",
      description: "",
      price: "$25",
      img: "imagenes/avena_con_leche.jpg",
    },
    {
      name: "Avena con leche mediana",
      description: "",
      price: "$30",
      img: "imagenes/avena_con_leche.jpg",
    },
    {
      name: "Avena con leche litro",
      description: "",
      price: "$60",
      img: "imagenes/avena_con_leche.jpg",
    },
    {
      name: "Panqueque",
      description: "",
      price: "$30",
      img: "imagenes/panqueque.jpg",
    },
    {
      name: "Panqueque con fruta",
      description: "",
      price: "$55",
      img: "imagenes/panqueque_con_fruta.jpg",
    },
    {
      name: "Panqueque de avena",
      description: "",
      price: "$45",
      img: "imagenes/panqueque_avena.jpg",
    },
    {
      name: "Galletas",
      description: "",
      price: "$28 / $35",
      img: "imagenes/galletas.jpg",
    },
    {
      name: "Concha con fruta",
      description: "",
      price: "$45",
      img: "imagenes/concha_con_fruta.jpg",
    },
    {
      name: "Pan dulce",
      description: "",
      price: "$15",
      img: "imagenes/pan.jpg",
    },
  ],
  Quesadillas: [
    {
      name: "Quesadilla",
      description: "",
      price: "$25",
      img: "imagenes/quesadilla.jpg",
    },
    {
      name: "Quesadilla con chorizo",
      description: "",
      price: "$35",
      img: "imagenes/quesadilla_chorizo.jpg",
    },
    {
      name: "Quesadilla con jamón",
      description: "",
      price: "$30",
      img: "imagenes/quesadilla_jamon.jpg",
    },
    {
      name: "Quesadilla con bistec",
      description: "",
      price: "$47",
      img: "imagenes/quesadilla_bistec.jpg",
    },
    {
      name: "Sincronizada",
      description:
        "Jamón, queso blanco, queso amarillo, jitomate, cebolla, lechuga, crema, catsup y mostaza",
      price: "$58",
      img: "imagenes/sincronizada.jpg",
    },
  ],
  Tacos: [
    {
      name: "Taco de bisteck",
      description: "",
      price: "$18",
      img: "imagenes/tacos_bistec_chorizo.jpg",
    },
    {
      name: "Taco de chorizo",
      description: "",
      price: "$16",
      img: "imagenes/tacos_bistec_chorizo.jpg",
    },
  ],
  Bebidas: [
    {
      name: "Café negro chico",
      description: "",
      price: "$22",
      img: "imagenes/cafe_negro.jpg",
    },
    {
      name: "Café mediano negro",
      description: "",
      price: "$25",
      img: "imagenes/cafe_negro.jpg",
    },
    {
      name: "Té caliente chico",
      description: "manzanilla, hierbabuena o limón",
      price: "$22",
      img: "imagenes/te.jpg",
    },
    {
      name: "Té caliente mediano",
      description: "manzanilla, hierbabuena o limón",
      price: "$25",
      img: "imagenes/te.jpg",
    },
    {
      name: "Canela chica",
      description: "",
      price: "$22",
      img: "imagenes/canela.jpg",
    },
    {
      name: "Canela medio litro",
      description: "",
      price: "$25",
      img: "imagenes/canela.jpg",
    },
    {
      name: "Café con leche chico",
      description: "",
      price: "$25",
      img: "imagenes/cafe_leche.jpg",
    },
    {
      name: "Café con leche mediano",
      description: "",
      price: "$30",
      img: "imagenes/cafe_leche.jpg",
    },
    {
      name: "Chocolate caliente chico",
      description: "",
      price: "$25",
      img: "imagenes/chocolate_caliente.jpg",
    },
    {
      name: "Chocolate caliente mediano",
      description: "Medio litro",
      price: "$30",
      img: "imagenes/chocolate_caliente.jpg",
    },
    {
      name: "Chocolate caliente grande",
      description: "1 litro",
      price: "$60",
      img: "imagenes/chocolate_caliente.jpg",
    },
    {
      name: "Chocomilk",
      description: "Fresa, vainilla o chocolate, medio litro",
      price: "$30",
      img: "imagenes/chocomilk.jpg",
    },
    {
      name: "Chocomilk litro",
      description: "Fresa, vainilla o chocolate, 1 litro",
      price: "$60",
      img: "imagenes/chocomilk.jpg",
    },
    {
      name: "Licuado medio litro",
      description: "Fresa, plátano o combinado, medio litro",
      price: "$35",
      img: "imagenes/licuado.jpg",
    },
    {
      name: "Licuado litro",
      description: "Fresa, plátano o combinado, 1 litro",
      price: "$70",
      img: "imagenes/licuado.jpg",
    },
    { name: "Licuado con avena", description: "", price: "$40" },
    {
      name: "Frappuccino",
      description: "",
      price: "$45",
      img: "imagenes/frappuccino.jpg",
    },
    {
      name: "Frappuccino de cajeta",
      description: "",
      price: "$50",
      img: "imagenes/frappuccino_cajeta.jpg",
    },
    {
      name: "Refresco",
      description: "Variedad refresco 600ml",
      price: "$30",
      img: "imagenes/refresco.jpg",
    },
    {
      name: "Jugo Jumex",
      description: "",
      price: "$25",
      img: "imagenes/jumex.jpg",
    },
    {
      name: "Gatorade",
      description: "",
      price: "$30",
      img: "imagenes/gatorade.jpg",
    },
    {
      name: "Suero",
      description: "Electrolic 625 ml",
      price: "$36",
      img: "imagenes/suero.jpg",
    },
    {
      name: "Agua natural",
      description: "",
      price: "$26",
      img: "imagenes/agua.jpg",
    },
    { name: "Amper", description: "", price: "$30", img: "imagenes/amper.jpg" },
    { name: "Agua fresca de litro", description: "", price: "$32" },
  ],
  Extras: [
    {
      name: "Salchicha extra",
      description: "",
      price: "$15",
      img: "imagenes/salchicha.jpg",
    },
    {
      name: "Carne de hamburguesa extra",
      description: "",
      price: "$43",
      img: "imagenes/carne_extra.jpg",
    },
    { name: "Ingrediente extra", description: "", price: "$11" },
    {
      name: "Extra de bistec",
      description: "",
      price: "$30",
      img: "imagenes/bistec_extra.jpg",
    },
    {
      name: "Extra de pierna",
      description: "",
      price: "$25",
      img: "imagenes/pierna_extra.jpg",
    },
    {
      name: "Papas a la francesa",
      description: "",
      price: "$30",
      img: "imagenes/papas_francesa.jpg",
    },
    {
      name: "Orden de salchipulpos",
      description: "",
      price: "$58",
      img: "imagenes/salchipulpos.jpg",
    },
    {
      name: "Ensalada",
      description: "Panela, jamón de pavo, lechuga, cebolla, jitomate",
      price: "$55",
      img: "imagenes/ensalada.jpg",
    },
    {
      name: "Salchitaco",
      description: "",
      price: "$24",
      img: "imagenes/salchitaco.jpg",
    },
    {
      name: "Chile con queso",
      description: "",
      price: "$34",
      img: "imagenes/chile_con_queso.jpg",
    },
  ],
  Sandwich: [
    {
      name: "De pierna",
      description: "",
      price: "$40",
      img: "imagenes/emparedado_pierna.jpg",
    },
    { name: "De bistec", description: "", price: "$45" },
    {
      name: "De jamón",
      description: "",
      price: "$28",
      img: "imagenes/emparedado_jamon.jpg",
    },
    { name: "De panela", description: "", price: "$28" },
    { name: "De frijoles con queso", description: "", price: "$28" },
    { name: "De huevo con jamón", description: "", price: "$28" },
    {
      name: "Cuernito con jamón",
      description: "",
      price: "$45",
      img: "imagenes/cuernito_jamon.jpg",
    },
  ],
  Lonches: [
    {
      name: "Lonche de pierna",
      description: "",
      price: "$65",
      img: "imagenes/lonche_pierna.jpg",
    },
    { name: "Lonche de huevo", description: "", price: "$55" },
    {
      name: "Lonche de huevo con jamón",
      description: "",
      price: "$55",
      img: "imagenes/lonche_huevo_jamon.jpg",
    },
    {
      name: "Lonche de frijoles con queso",
      description: "",
      price: "$55",
      img: "imagenes/lonche_frijoles.jpg",
    },
    { name: "Lonche de jamón", description: "", price: "$55" },
    {
      name: "Lonche de panela",
      description: "",
      price: "$55",
      img: "imagenes/lonche_panela.jpg",
    },
    {
      name: "Lonche de bistec",
      description: "Frijoles, cebolla y bistec",
      price: "$85",
      img: "imagenes/lonche_bistec.jpg",
    },
    {
      name: "Lonche Tetas",
      description:
        "Pierna, jamón, panela, queso blanco, queso amarillo, salchicha, tocino, jitomate, cebolla, lechuga, crema, catsup y mostaza",
      price: "$120",
      img: "imagenes/lonche_tetas.jpg",
    },
  ],
};


function App() {
  const theme = useTheme();
  const [selectedCategory, setSelectedCategory] = React.useState(0);
  const [expandedDescription, setExpandedDescription] = useState({});

  // Estado para el modal
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  // Función para manejar la expansión de la descripción
  const handleExpandDescription = (idx) => {
    setExpandedDescription((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Funciones para manejar el modal
  const handleOpenModal = (image) => {
    setSelectedImage(image);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage("");
  };

  const categories = Object.keys(menuData);

  return (
    <Box sx={{ flexGrow: 1, paddingBottom: 4, maxWidth: "1200px", mx: "auto" }}>
      {/* Header */}
      <AppBar position="sticky">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <img
            src="/imagenes/logo.png"
            alt="Logo del Restaurante"
            style={{
              width: 32, // Tamaño del ancho para pantallas grandes
              height: 32,
              marginRight: 8,
            }}
          />
          <Typography variant="h6" component="div">
            Burritas Baja Avión
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Category Tabs */}
      <Tabs
        value={selectedCategory}
        onChange={handleCategoryChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="category tabs"
        sx={{
          backgroundColor: "white",
          marginBottom: 2,
          position: "sticky",
          top: 64,
          zIndex: 1100,
        }}>
        {categories.map((category, index) => (
          <Tab
            key={category}
            label={category === "Inicio" ? <HomeIcon /> : category}
          />
        ))}
      </Tabs>

      {/* Category Content */}
      <Box sx={{ padding: 2 }}>
        {categories.map((category, index) => (
          <Box
            key={category}
            role="tabpanel"
            hidden={selectedCategory !== index}
            aria-labelledby={`tab-${index}`}>
            {selectedCategory === index && (
              <>
                {category === "Inicio" ? (
                  <Box textAlign="center">
                    <img
                      src="/imagenes/bajando_avion.png"
                      alt="Logo del Restaurante"
                      style={{
                        maxWidth: "80%", // Reduce el ancho máximo en pantallas grandes
                        height: "auto",
                        marginBottom: 20,
                      }}
                    />

                    {/* Contenedor para centrar el cuadro de horario */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 2,
                      }}>
                      <Box
                        sx={{
                          padding: 2,
                          borderRadius: 2,
                          backgroundColor: theme.palette.background.paper,
                          boxShadow: 1,
                          textAlign: "center", // Centra el texto dentro del cuadro
                          maxWidth: "400px", // Controla el ancho máximo del cuadro
                        }}>
                        <Typography
                          variant="h6"
                          sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                          Horario de Servicio
                        </Typography>
                        <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
                          Lunes a Domingo: 9:00 pm - 9:00 am
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: "1.1rem" }}>
                          Descansamos los Martes
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontSize: "1rem" }}>
                          Servicio a Domicilio termina a las 6:00 am
                        </Typography>
                      </Box>
                    </Box>

                    {/* Contenedor para plataformas de delivery */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 2,
                      }}>
                      <Box
                        sx={{
                          padding: 2,
                          borderRadius: 2,
                          backgroundColor: theme.palette.background.paper,
                          boxShadow: 1,
                          textAlign: "center",
                          maxWidth: "400px",
                        }}>
                        <Typography
                          variant="h6"
                          sx={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                          También disponible en:
                        </Typography>
                        <Typography variant="body1" sx={{ fontSize: "1.1rem", marginTop: 1 }}>
                          UberEats • Didi • Rappi
                        </Typography>
                      </Box>
                    </Box>

                    {/* Mapa con ancho máximo y centrado */}
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "600px", // Controla el ancho máximo del mapa
                        height: "300px",
                        mx: "auto", // Centra el mapa
                        marginTop: 2,
                      }}>
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.9347415311368!2d-103.30488902403661!3d20.672233799927096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b17cdf93ab33%3A0xf7d6c4472896c8ff!2sC.%20Industria%202513%2C%20Jardines%20de%20Guadalupe%2C%2044740%20Guadalajara%2C%20Jal.!5e0!3m2!1ses!2smx!4v1730310948848!5m2!1ses!2smx"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        title="Ubicación en Google Maps"></iframe>
                    </Box>

                    <Typography
                      variant="body1"
                      sx={{
                        marginTop: 2,
                        fontSize: "1rem",
                        color: "text.secondary",
                      }}>
                      Estamos a sus órdenes en el mercado Felipe Ángeles, calle
                      Industria 2513, cruce con Huertas y Guelatao, Guadalajara,
                      Jalisco.
                    </Typography>

                    <Box
                      sx={{
                        marginTop: 2,
                        display: "flex",
                        gap: 2,
                        justifyContent: "center",
                      }}>
                      <Button
                        variant="contained"
                        color="primary"
                        href="https://www.facebook.com/RentaDeDiablosVentaDeCafeYBurritaspepe"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          minWidth: "40px",
                          minHeight: "40px",
                          padding: "8px",
                        }}>
                        <FacebookIcon />
                      </Button>
                      <Button
                        variant="contained"
                        color="success"
                        href="https://api.whatsapp.com/send?phone=5213314701601&text=Enlace..."
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          minWidth: "40px",
                          minHeight: "40px",
                          padding: "8px",
                        }}>
                        <WhatsAppIcon />
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Grid
                    container
                    spacing={2}
                    columns={{ xs: 12, sm: 6, md: 4 }}>
                    {menuData[category].map((dish, idx) => {
                      const hasDescription = !!dish.description;
                      const isLongDescription =
                        hasDescription &&
                        dish.description.length > MAX_DESCRIPTION_LENGTH;
                      const descriptionToShow = expandedDescription[idx]
                        ? dish.description
                        : `${dish.description.slice(
                            0,
                            MAX_DESCRIPTION_LENGTH
                          )}${isLongDescription ? "..." : ""}`;

                      return (
                        <Grid item xs={12} sm={6} md={4} key={idx}>
                          <Card
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "160px", // Altura mínima para todas las tarjetas
                            }}>
                            {dish.img ? (
                              <CardMedia
                                component="img"
                                sx={{
                                  width: 100,
                                  height: 100,
                                  objectFit: "cover",
                                  flexShrink: 0,
                                  cursor: "pointer", // Cambia el cursor para indicar que es clicable
                                }}
                                image={dish.img}
                                alt={dish.name}
                                onClick={() => handleOpenModal(dish.img)} // Añade esta línea
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: 100,
                                  height: 100,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  bgcolor: "grey.300",
                                  flexShrink: 0,
                                }}>
                                <FastfoodIcon
                                  sx={{ fontSize: 40, color: "grey.600" }}
                                />
                              </Box>
                            )}
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                padding: 2,
                                minHeight: "120px", // Altura mínima para contenido
                              }}>
                              <Typography variant="h6">{dish.name}</Typography>
                              {hasDescription && (
                                <Box sx={{ flexGrow: 1 }}>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      WebkitLineClamp: expandedDescription[idx]
                                        ? "unset"
                                        : 2, // Muestra 2 líneas cuando está contraído
                                    }}>
                                    {descriptionToShow}
                                  </Typography>
                                  {isLongDescription &&
                                    !expandedDescription[idx] && (
                                      <Button
                                        size="small"
                                        onClick={() =>
                                          handleExpandDescription(idx)
                                        }>
                                        Ver más
                                      </Button>
                                    )}
                                  {expandedDescription[idx] && (
                                    <Button
                                      size="small"
                                      onClick={() =>
                                        handleExpandDescription(idx)
                                      }>
                                      Ver menos
                                    </Button>
                                  )}
                                </Box>
                              )}
                              <Typography variant="subtitle1" color="primary">
                                {dish.price}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
              </>
            )}
          </Box>
        ))}
      </Box>
      {/* Modal para mostrar la imagen completa */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <Fade in={openModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 1,
              outline: "none",
            }}>
            <img
              src={selectedImage}
              alt="Imagen del producto"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                display: "block",
                margin: "0 auto",
              }}
            />
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
}

export default App;
